<template>
  <div class="box" :style="{ '--rotation-angle': `${targetDeg}deg`, width: `${(outerRingDiameter / 1920) * 100}vw`, height: `${(outerRingDiameter / 1920) * 100}vw` }">
    <div :style="roundStyle" :class="{ animation: animation }" class="round"></div>
    <div class="gap" :style="{ width: `${(innerRingDiameter / 1920) * 100}vw`, height: `${(innerRingDiameter / 1920) * 100}vw`, background: innerRingBackgroundColor }">
      <slot />
    </div>
    <div v-if="point" class="point" :class="{ animation: animation }" :style="{ transform: `rotate(${this.targetDeg || 330}deg)` }">
      <div :style="{ background: this.roundColor }"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // 动画持续时间
    duration: {
      type: Number,
      default: 800,
    },
    // 旋转角度
    // targetDeg: {
    //   type: Number,
    //   default: 330,
    // },
    // 外圆环直径
    outerRingDiameter: {
      type: Number,
      default: 138,
    },
    // 内圆环直径,内外圆环直径之差影响圆环的宽度
    innerRingDiameter: {
      type: Number,
      default: 132,
    },
    // 内圆环颜色
    innerRingBackgroundColor: {
      type: String,
      default: '#022061',
    },
    // 是否显示端点
    point: {
      type: Boolean,
      default: false,
    },
    // 圆环颜色
    roundColor: {
      type: String,
      default: '#00AEFF',
    },
    // 是否有连续动画
    animation: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      roundStyle: {},
      pointStyle: {},
      targetDeg: 330,
    }
  },
  // watch: {
  //   targetDeg: {
  //     immediate: true,
  //     handler(val) {
  //       this.init()
  //     },
  //   },
  // },
  created() {
    this.init()
  },
  mounted() {
    setTimeout(() => {
      if (!this.animation) this.roundStyle.transform = `rotate(0deg)`
      // this.pointStyle.transform = `rotate(${this.targetDeg || 0}deg)`
    }, 200)
  },
  methods: {
    init() {
      const deg = this.targetDeg || 330
      if (this.animation) {
        this.roundStyle = {
          background: `conic-gradient(#b7defd17 0, #b7defd17 ${deg - 160}deg, ${this.roundColor} ${deg}deg, #b7defd17 0)`,
        }
      } else {
        this.roundStyle = {
          transform: `rotate(${-deg}deg)`,
          transition: `transform ${this.duration}ms ease-in-out`,
          background: `conic-gradient(#b7defd17 0, #b7defd17 ${deg - 160}deg, ${this.roundColor} ${deg}deg, #b7defd17 0)`,
        }
      }
      // this.pointStyle = {
      //   transform: `rotate(${this.targetDeg || 0}deg)`,
      //    transition: `transform ${this.duration}ms ease-in-out`,
      // }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/charts.scss';
.box {
  position: relative;
  .animation {
    animation: rotateRound 2s linear infinite; /* 添加动画 */
  }
  .round {
    width: 100%;
    height: 100%;
    border-radius: 9999px;
  }
  .point {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    z-index: 999;

    div {
      position: absolute;
      width: vh(6);
      height: vh(6);
      left: 50%;
      top: vh(-2);
      transform: translateX(-50%);
      border-radius: 99999px;
    }
  }
  .gap {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 99999px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

/* 定义动画 */
@keyframes rotateRound {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes rotatePoint {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(var(--rotation-angle));
  }
}
</style>
